import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NewSupplierComponent } from 'frontEndelScreens/DEMANDE_REFERENCEMENT/new-supplier/new-supplier.component';
import { SearchSuppliersListComponent } from 'frontEndelScreens/RECHERCHE_FOURNISSEURS/search-suppliers/search-suppliers.component';
import { ExtusersListsComponent } from 'frontEndelScreens/COMPTES_EXTERNES/extusers-lists/extusers-lists.component';
import { MsalGuard } from '@azure/msal-angular';
import {  
  SupplierDetailsComponent,
  SupplierDescriptifComponent,
  SupplierAccountInfoComponent,
  SupplierKnowledgeComponent,
  SupplierRegulDocsComponent,
  SupplierQualityDocsComponent,
  AccidentologieComponent
   } from 'ngx-paf-common';
   
import { SourcingComponent } from 'frontEndelScreens/LISTES/sourcing/sourcing.component';
import { LstTasksComponent } from 'frontEndelScreens/LISTES/lst-tasks/lst-tasks.component';
import { PilotageEndelComponent } from 'frontEndelScreens/PILOTAGE_ENDEL/pilotage-endel/pilotage-endel.component';
import { RelancesDocumentaireComponent } from 'frontEndelScreens/ADMINISTRATION/relances-documentaire/relances-documentaire.component';
import { LstDocumentairesComponent } from 'frontEndelScreens/LISTES/lst-documentaires/lst-documentaires.component';
import { FinancesComponent } from 'frontEndelScreens/FINANCES/finances-main/finances.component';
import { LstIntUsersComponent } from 'frontEndelScreens/ADMINISTRATION/lst-int-users/lst-int-users.component';
import { LstContactsComponent } from 'frontEndelScreens/ADMINISTRATION/lst-contacts/lst-contacts.component';
import { LstConnexionsComponent } from 'frontEndelScreens/ADMINISTRATION/lst-connexions/lst-connexions.component';
import { LockedUserComponent } from 'frontEndelScreens/locked-user/locked-user.component';

import { LoggedOutAzureComponent } from 'frontEndelScreens/logged-out-azure/logged-out-azure.component';
import { LogoutComponent } from 'frontEndelScreens/logout/logout.component';
import { LoginCallbackComponent } from 'frontEndelScreens/login-callback/login-callback.component';
import { LstEncoursComponent } from 'frontEndelScreens/LISTES/lst-encours/lst-encours.component';
import { CadeauPierreComponent } from './ymo-message/ymo-message.component';
import { FinancesDetailCmdsComponent } from 'frontEndelScreens/FINANCES/finances-detail-cmds/finances-detail-cmds.component';

const routes: Routes = [
  {path:'suppliers', component: SearchSuppliersListComponent, canActivate: [MsalGuard]},
  {path:'new-supplier', component: NewSupplierComponent, canActivate: [MsalGuard]},
  {path:'supplier-details/:id', component: SupplierDetailsComponent, canActivate: [MsalGuard]},
  {path:'supplier-details/:id/:fromscreen', component: SupplierDetailsComponent, canActivate: [MsalGuard]},
  {path:'supplier-details/:id/initial-tab/:initialTab', component: SupplierDetailsComponent, canActivate: [MsalGuard]},
  {path:'supplier-descriptif',component:SupplierDescriptifComponent, outlet:'supplierDetailOutlet', canActivate: [MsalGuard]},
  {path:'supplier-account-info',component:SupplierAccountInfoComponent, outlet:'supplierDetailOutlet', canActivate: [MsalGuard]},
  {path:'supplier-knowledge',component:SupplierKnowledgeComponent, outlet:'supplierDetailOutlet', canActivate: [MsalGuard]},
  {path:'supplier-regul-docs',component:SupplierRegulDocsComponent, outlet:'supplierDetailOutlet', canActivate: [MsalGuard]},
  {path:'supplier-quality-docs',component:SupplierQualityDocsComponent, outlet:'supplierDetailOutlet', canActivate: [MsalGuard]},
  {path:'accidentologie',component:AccidentologieComponent, outlet:'accidentologieOutlet', canActivate: [MsalGuard]},
  {path:'sourcing', component:SourcingComponent, canActivate:[MsalGuard]},
  {path:'list-tasks', component:LstTasksComponent, canActivate:[MsalGuard]},
  {path:'list-encours', component:LstEncoursComponent, canActivate:[MsalGuard]},
  {path:'list-documentaires', component:LstDocumentairesComponent, canActivate:[MsalGuard]},
  {path:'pilotage-endel', component:PilotageEndelComponent, outlet:'pilotageEndelOutlet', canActivate:[MsalGuard]},
  {path:'logout', component:LogoutComponent},
  {path:'finances/detail-commandes', component:FinancesDetailCmdsComponent, canActivate:[MsalGuard]},
  {path:'finances/general', component:FinancesComponent, canActivate:[MsalGuard]},
  {path:'administration/extusers', component: ExtusersListsComponent, canActivate: [MsalGuard]},
  {path:'administration/intusers', component:LstIntUsersComponent, canActivate:[MsalGuard]},
  {path:'administration/relances-documentaires', component:RelancesDocumentaireComponent, canActivate:[MsalGuard]},
  {path:'administration/lst-contacts', component:LstContactsComponent, canActivate:[MsalGuard]},
  {path:'administration/lst-connexions', component:LstConnexionsComponent, canActivate:[MsalGuard]},
  {path: 'loggedout', component:LoggedOutAzureComponent},
  {path:'login', component: LoginCallbackComponent, canActivate:[MsalGuard]},
  {path:'login/callback', component: LoginCallbackComponent, canActivate:[MsalGuard]},
  {path:'message-ymo', component: CadeauPierreComponent, canActivate:[MsalGuard]},
  {path:'locked-user', component:LockedUserComponent},
  { path: 'home', redirectTo: 'login', pathMatch: 'full' },  
  { path: '', redirectTo: 'login', pathMatch: 'full' },  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
